"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Talenzap APIs
 * API documentation for the backend services of Talenzap
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserNotificationsControllerGetNotificationsV1StatusEnum = exports.NotificationsUserApi = exports.NotificationsUserApiFactory = exports.NotificationsUserApiFp = exports.NotificationsUserApiAxiosParamCreator = void 0;
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * NotificationsUserApi - axios parameter creator
 * @export
 */
var NotificationsUserApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get list of notifications for user
         * @param {UserNotificationsControllerGetNotificationsV1StatusEnum} [status] Read status filter
         * @param {number} [skip] Number of items to skip (default: 0)
         * @param {number} [take] Number of items to take (default: 20)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationsControllerGetNotificationsV1: function (status_1, skip_1, take_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([status_1, skip_1, take_1], args_1, true), void 0, function (status, skip, take, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/v1/notifications/list";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (status !== undefined) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (skip !== undefined) {
                                localVarQueryParameter['skip'] = skip;
                            }
                            if (take !== undefined) {
                                localVarQueryParameter['take'] = take;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get detailed winner information when clicking on winner notification
         * @param {string} competitionId Competition ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationsControllerGetWinnerNotificationDetailsV1: function (competitionId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([competitionId_1], args_1, true), void 0, function (competitionId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'competitionId' is not null or undefined
                            (0, common_1.assertParamExists)('userNotificationsControllerGetWinnerNotificationDetailsV1', 'competitionId', competitionId);
                            localVarPath = "/v1/notifications/winner-details";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            if (competitionId !== undefined) {
                                localVarQueryParameter['competitionId'] = competitionId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Mark a notification as read (when user clicks on it)
         * @param {string} notificationId Notification ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationsControllerMarkNotificationAsReadV1: function (notificationId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([notificationId_1], args_1, true), void 0, function (notificationId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'notificationId' is not null or undefined
                            (0, common_1.assertParamExists)('userNotificationsControllerMarkNotificationAsReadV1', 'notificationId', notificationId);
                            localVarPath = "/v1/notifications/{notificationId}/mark-read"
                                .replace("{".concat("notificationId", "}"), encodeURIComponent(String(notificationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Register or update user device for push notifications
         * @param {RegisterDeviceDto} registerDeviceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationsControllerRegisterDeviceV1: function (registerDeviceDto_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([registerDeviceDto_1], args_1, true), void 0, function (registerDeviceDto, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'registerDeviceDto' is not null or undefined
                            (0, common_1.assertParamExists)('userNotificationsControllerRegisterDeviceV1', 'registerDeviceDto', registerDeviceDto);
                            localVarPath = "/v1/notifications/device/token";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(registerDeviceDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Unregister device (on logout)
         * @param {UnregisterDeviceDto} unregisterDeviceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationsControllerUnregisterDeviceV1: function (unregisterDeviceDto_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([unregisterDeviceDto_1], args_1, true), void 0, function (unregisterDeviceDto, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'unregisterDeviceDto' is not null or undefined
                            (0, common_1.assertParamExists)('userNotificationsControllerUnregisterDeviceV1', 'unregisterDeviceDto', unregisterDeviceDto);
                            localVarPath = "/v1/notifications/device/unregister";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication bearer required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication bearer required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(unregisterDeviceDto, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.NotificationsUserApiAxiosParamCreator = NotificationsUserApiAxiosParamCreator;
/**
 * NotificationsUserApi - functional programming interface
 * @export
 */
var NotificationsUserApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.NotificationsUserApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get list of notifications for user
         * @param {UserNotificationsControllerGetNotificationsV1StatusEnum} [status] Read status filter
         * @param {number} [skip] Number of items to skip (default: 0)
         * @param {number} [take] Number of items to take (default: 20)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationsControllerGetNotificationsV1: function (status, skip, take, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userNotificationsControllerGetNotificationsV1(status, skip, take, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['NotificationsUserApi.userNotificationsControllerGetNotificationsV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get detailed winner information when clicking on winner notification
         * @param {string} competitionId Competition ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationsControllerGetWinnerNotificationDetailsV1: function (competitionId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userNotificationsControllerGetWinnerNotificationDetailsV1(competitionId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['NotificationsUserApi.userNotificationsControllerGetWinnerNotificationDetailsV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Mark a notification as read (when user clicks on it)
         * @param {string} notificationId Notification ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationsControllerMarkNotificationAsReadV1: function (notificationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userNotificationsControllerMarkNotificationAsReadV1(notificationId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['NotificationsUserApi.userNotificationsControllerMarkNotificationAsReadV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Register or update user device for push notifications
         * @param {RegisterDeviceDto} registerDeviceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationsControllerRegisterDeviceV1: function (registerDeviceDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userNotificationsControllerRegisterDeviceV1(registerDeviceDto, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['NotificationsUserApi.userNotificationsControllerRegisterDeviceV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Unregister device (on logout)
         * @param {UnregisterDeviceDto} unregisterDeviceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationsControllerUnregisterDeviceV1: function (unregisterDeviceDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.userNotificationsControllerUnregisterDeviceV1(unregisterDeviceDto, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['NotificationsUserApi.userNotificationsControllerUnregisterDeviceV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.NotificationsUserApiFp = NotificationsUserApiFp;
/**
 * NotificationsUserApi - factory interface
 * @export
 */
var NotificationsUserApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.NotificationsUserApiFp)(configuration);
    return {
        /**
         *
         * @summary Get list of notifications for user
         * @param {UserNotificationsControllerGetNotificationsV1StatusEnum} [status] Read status filter
         * @param {number} [skip] Number of items to skip (default: 0)
         * @param {number} [take] Number of items to take (default: 20)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationsControllerGetNotificationsV1: function (status, skip, take, options) {
            return localVarFp.userNotificationsControllerGetNotificationsV1(status, skip, take, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get detailed winner information when clicking on winner notification
         * @param {string} competitionId Competition ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationsControllerGetWinnerNotificationDetailsV1: function (competitionId, options) {
            return localVarFp.userNotificationsControllerGetWinnerNotificationDetailsV1(competitionId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Mark a notification as read (when user clicks on it)
         * @param {string} notificationId Notification ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationsControllerMarkNotificationAsReadV1: function (notificationId, options) {
            return localVarFp.userNotificationsControllerMarkNotificationAsReadV1(notificationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Register or update user device for push notifications
         * @param {RegisterDeviceDto} registerDeviceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationsControllerRegisterDeviceV1: function (registerDeviceDto, options) {
            return localVarFp.userNotificationsControllerRegisterDeviceV1(registerDeviceDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Unregister device (on logout)
         * @param {UnregisterDeviceDto} unregisterDeviceDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationsControllerUnregisterDeviceV1: function (unregisterDeviceDto, options) {
            return localVarFp.userNotificationsControllerUnregisterDeviceV1(unregisterDeviceDto, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.NotificationsUserApiFactory = NotificationsUserApiFactory;
/**
 * NotificationsUserApi - object-oriented interface
 * @export
 * @class NotificationsUserApi
 * @extends {BaseAPI}
 */
var NotificationsUserApi = /** @class */ (function (_super) {
    __extends(NotificationsUserApi, _super);
    function NotificationsUserApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get list of notifications for user
     * @param {UserNotificationsControllerGetNotificationsV1StatusEnum} [status] Read status filter
     * @param {number} [skip] Number of items to skip (default: 0)
     * @param {number} [take] Number of items to take (default: 20)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsUserApi
     */
    NotificationsUserApi.prototype.userNotificationsControllerGetNotificationsV1 = function (status, skip, take, options) {
        var _this = this;
        return (0, exports.NotificationsUserApiFp)(this.configuration).userNotificationsControllerGetNotificationsV1(status, skip, take, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get detailed winner information when clicking on winner notification
     * @param {string} competitionId Competition ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsUserApi
     */
    NotificationsUserApi.prototype.userNotificationsControllerGetWinnerNotificationDetailsV1 = function (competitionId, options) {
        var _this = this;
        return (0, exports.NotificationsUserApiFp)(this.configuration).userNotificationsControllerGetWinnerNotificationDetailsV1(competitionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Mark a notification as read (when user clicks on it)
     * @param {string} notificationId Notification ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsUserApi
     */
    NotificationsUserApi.prototype.userNotificationsControllerMarkNotificationAsReadV1 = function (notificationId, options) {
        var _this = this;
        return (0, exports.NotificationsUserApiFp)(this.configuration).userNotificationsControllerMarkNotificationAsReadV1(notificationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Register or update user device for push notifications
     * @param {RegisterDeviceDto} registerDeviceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsUserApi
     */
    NotificationsUserApi.prototype.userNotificationsControllerRegisterDeviceV1 = function (registerDeviceDto, options) {
        var _this = this;
        return (0, exports.NotificationsUserApiFp)(this.configuration).userNotificationsControllerRegisterDeviceV1(registerDeviceDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Unregister device (on logout)
     * @param {UnregisterDeviceDto} unregisterDeviceDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsUserApi
     */
    NotificationsUserApi.prototype.userNotificationsControllerUnregisterDeviceV1 = function (unregisterDeviceDto, options) {
        var _this = this;
        return (0, exports.NotificationsUserApiFp)(this.configuration).userNotificationsControllerUnregisterDeviceV1(unregisterDeviceDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return NotificationsUserApi;
}(base_1.BaseAPI));
exports.NotificationsUserApi = NotificationsUserApi;
/**
 * @export
 */
exports.UserNotificationsControllerGetNotificationsV1StatusEnum = {
    All: 'all',
    Read: 'read',
    Unread: 'unread'
};
